import React, { useEffect, useState } from 'react'
import { Search } from 'lucide-react'
import { useNavigate, useLocation } from 'react-router-dom'
import { HTTP } from '../api/http-common'
import { ChevronDown } from 'lucide-react';
import '../styling/homepage.css'
import Select from 'react-select'; // Import react-select
import HomeGrid from './HomeGrid';
import BusinessCards from './BusinessCards';
const Home = () => {
  const location = useLocation();
  const [cityList, setCityList] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [totalFilteredCouponsCount, setTotalFilteredCouponsCount] = useState(0);
  const [pagination, setPagination] = useState({ page: '1', limit: '100' });
  const [formData, setFormData] = useState({
    city_id: '',
    category_id: ''
  });

  const [vendorList, setVendorList] = useState({});
  // Fetch cities
  const fetchCities = async () => {
    try {
      const access_token = localStorage.getItem('access_token');
      const config = {
        headers: { "Content-Type": "application/json", token: access_token },
      };
      const params = {
        category_id: formData.category_id
      };
      const response = await HTTP.post('/vendors_address/city', params);

      // const response = await HTTP.get("vendors_address/city", config,params);

      if (response.status === 200) {
        setCityList(response.data); // Assume response.data contains the list of cities
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  // Fetch categories
  const loadCategories = async () => {
    try {
      let fields = {
        filters: {
          city_id: formData.city_id
        },
        pagination: pagination,
        sorting: { field: 'name', type: 'asc' },
      };
      const response = await HTTP.post("/business_cate/list/all", fields);
      if (response.status === 200) {
        setCategoriesList(response.data.contents);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };


  const loadTotalCouponCount = async () => {
    try {
      const params = new URLSearchParams(location.search);
      let fields = {
        city_id: formData.city_id,
        category_id: formData.category_id
      };
      const response = await HTTP.post("/vendors_address/total_coupon_count", fields);
      // console.log(response)
      if (response.status === 200) {
        setTotalFilteredCouponsCount(response.data.total);
      }
    } catch (error) {
      console.error("Error fetching total count:", error);
    }
  };

  // const loadActiveVendors = async () => {
  //   try {
  //     let requestData = {
  //       filters: {
  //         search_value: formData.searchValue || null,
  //         verification_status: formData.verificationStatus || null
  //       },
  //       pagination: {
  //         page: 1,
  //         limit: 3
  //       },
  //       sorting: {
  //         field: "",
  //         type: ""
  //       }
  //     };

  //     const response = await HTTP.post("/vendors/active_vendor_list", requestData);

  //     if (response.status === 200) {
  //       setVendorList(response.data.top_active_vendors);
  //       // setTotalVendors(response.data.total_count); 
  //     }
  //   } catch (error) {
  //     console.error("Error fetching active vendors:", error);
  //   }
  // };
  const loadActiveVendors = async () => {
    try {
      let requestData = {
        filters: {
          search_value: formData.searchValue || null,
          verification_status: formData.verificationStatus || null,
          is_visible: true,
          id: null,
          plan_expiration_date: new Date().toISOString().split("T")[0]
        },
        pagination: {
          page: 1,
          limit: 30
        },
        sorting: {
          field: "",
          type: ""
        }
      };

      const response = await HTTP.post("/vendors/list", requestData);

      if (response.status === 200) {
        setVendorList(response.data.contents);
        // setTotalVendors(response.data.total_count); 
      }
    } catch (error) {
      console.error("Error fetching active vendors:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const navigate = useNavigate();

  const showResult = () => {
    const query = new URLSearchParams(formData).toString();
    navigate(`/explore?${query}`);
  };

  useEffect(() => {
    loadActiveVendors();
  }, []);
  useEffect(() => {
    // if(formData.category_id){
    //   fetchCities();
    // }
    // if(formData.city_id){
    //   loadCategories();
    // }
    fetchCities();
    loadCategories();
    loadTotalCouponCount();
  }, [formData]);

  return (
    <>
      <div className="home-page-main w-full" >
        <div className="home-page-wrapper">
          <div className="flex items-center justify-evenly h-full flex-col">
            <div className="text-white text-center">
              <h1
                className='font-semibold text-[65px]'
              >
                Family Fun Arizona
              </h1>
              <p
                className='mt-[10px] mb-[45px] text-[20px]'
              >
                Connecting Families with FUN in the Valley of the Sun!
              </p>
            </div>
            <div
              className="mx-1 bg-white mx-auto max-w-[60%] w-full px-4 py-6 custom-searchbox rounded-[5px]"
            >
              <div className="flex">
                {/* Category selection */}
                <div className="search-box-input">
                  <select
                    name="category_id"
                    value={formData.category_id}
                    onChange={handleChange}
                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  >
                    <option value="">Select Category</option>
                    {Array.isArray(categoriesList) && categoriesList.length > 0
                      ? categoriesList.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name} ({category.total_coupon_count})
                        </option>
                      ))
                      : <option value="">No categories available</option>}
                  </select>
                </div>

                {/* City selection */}
                <div className="search-box-input">
                  <select
                    name="city_id"
                    value={formData.city_id}
                    onChange={handleChange}
                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  >
                    <option value="">Select City</option>
                    {Array.isArray(cityList) && cityList.length > 0
                      ? cityList.map((city) => (
                        <option key={city.id} value={city.id}>
                          {city.name} ({city.total_coupon_count})
                        </option>
                      ))
                      : <option value="">No cities available</option>}
                  </select>
                </div>
                <div className="w-1/3">
                  <button
                    onClick={showResult}
                    className='theme-button cursor-pointer search-box-button flex flex-col items-center justify-center font-semibold text-sm'
                  >
                    <span className='flex items-center'>
                      <Search className='w-[15px] mr-1.5' />
                      <span>Search Family Fun Deals! ({totalFilteredCouponsCount})</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <HomeGrid />
      <BusinessCards data={vendorList} title={"Meet Our Preferred Business Partners!"} />
    </>
  );
};

export default Home;
